import React from 'react';

export default function TimezoneSelector({ timezone, setTimezone }) {
    return (
        <div className="mb-2">
            <label htmlFor="timezone" className="form-label fw-bold">Timezone</label>
            <select
                id="timezone"
                className="form-select"
                value={timezone}
                onChange={(e) => setTimezone(e.target.value)}
            >
                {Intl.supportedValuesOf("timeZone").map(tz => (
                    <option key={tz} value={tz}>{tz}</option>
                ))}
            </select>
        </div>
    );
}
